import { FC, useState } from 'react';
import loadable from '@loadable/component';
import {
  ContentLoader,
  Menu,
  SupportModalToggleContext,
  SupportModalToggleContextType,
  SupportModalHolder,
} from '@edikk-edikk/ui';
import { useUserContext } from '@edikk-edikk/shared';
import { Controls } from '#baseMenu/components/controls/Controls';
import { Variant } from '#baseMenu/objects';
import { MenuWrapperContext, MenuWrapperContextType } from '#baseMenu/contexts';

const SupportModal = loadable(() => import('@edikk-edikk/ui/support-modal/containers'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ SupportModal: Component }) => Component,
});

const MenuContentAsync = loadable(() => import('#baseMenu/components/content/MenuContentWrapper'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ MenuContentWrapper: Component }) => Component,
});

const MenuWrapper: FC = () => {
  const { isAuth } = useUserContext();
  const defaultVariant = isAuth ? Variant.loggedIn : Variant.signIn;
  const [variant, setVariant] = useState<Variant>(defaultVariant);

  const menuWrapperContextValue: MenuWrapperContextType = {
    variant,
    setVariant,
  };

  const supportModalToggleContextValue: SupportModalToggleContextType = {
    SupportModal,
  };

  return (
    <SupportModalToggleContext.Provider value={supportModalToggleContextValue}>
      <MenuWrapperContext.Provider value={menuWrapperContextValue}>
        <Menu
          MenuContentAsync={MenuContentAsync}
          controlActions={<Controls />}
        />
        <SupportModalHolder />
      </MenuWrapperContext.Provider>
    </SupportModalToggleContext.Provider>
  );
};

export { MenuWrapper };
